import React, { useState, useEffect } from 'react';
import { useShoppingCart } from '../hooks/useShoppingCart';
import ProductList from '../components/ProductList';
import '../styles/subscriptions.css';

import { useTranslation } from 'react-i18next';

function Subscriptions({products}) {
	const [selectedInterval, setSelectedInterval] = useState('year');
	const { t } = useTranslation();

	const { interval, changeInterval } = useShoppingCart();

	useEffect(() => {
		if (interval !== selectedInterval) {
			changeInterval(selectedInterval);
		}
	}, [changeInterval, interval, selectedInterval]);

	useEffect(() => {
		if (interval !== selectedInterval) {
			setSelectedInterval(interval);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="text-center mt-4">
			<div className="billing-toggle mx-auto mb-4">
				<div className="toggle-bg">
					<div
						className={`toggle-slider ${
						selectedInterval === 'year' ? 'right' : 'left'
						}`}
					></div>
					<button
						type="button"
						className={`toggle-btn ${
						selectedInterval === 'month' ? 'active' : ''
						}`}
						onClick={() => setSelectedInterval('month')}
					>
						{t("monthly")}
					</button>
					<button
						type="button"
						className={`toggle-btn ${
						selectedInterval === 'year' ? 'active' : ''
						}`}
						onClick={() => setSelectedInterval('year')}
					>
						{t("yearly")}
					</button>
				</div>
			</div>

			{products ? <ProductList products={products} selectedInterval={selectedInterval} category={'main'}/> : <div><span className="spinner-border spinner-border-sm me-2"></span></div>}
		</div>
	);
}

export default Subscriptions;